/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccessTokenOpts } from './AccessTokenOpts';
import {
    AccessTokenOptsFromJSON,
    AccessTokenOptsFromJSONTyped,
    AccessTokenOptsToJSON,
} from './AccessTokenOpts';
import type { TokenMetadataFields } from './TokenMetadataFields';
import {
    TokenMetadataFieldsFromJSON,
    TokenMetadataFieldsFromJSONTyped,
    TokenMetadataFieldsToJSON,
} from './TokenMetadataFields';

/**
 * Configuration for OAuth2.0. Must be provided if authType is oauth2.
 * @export
 * @interface Oauth2Opts
 */
export interface Oauth2Opts {
    /**
     * 
     * @type {string}
     * @memberof Oauth2Opts
     */
    grantType: Oauth2OptsGrantTypeEnum;
    /**
     * The authorization URL.
     * @type {string}
     * @memberof Oauth2Opts
     */
    authURL?: string;
    /**
     * The token URL.
     * @type {string}
     * @memberof Oauth2Opts
     */
    tokenURL: string;
    /**
     * Whether scopes are required to be known ahead of the OAuth flow.
     * @type {boolean}
     * @memberof Oauth2Opts
     */
    explicitScopesRequired: boolean;
    /**
     * Whether the workspace is required to be known ahead of the OAuth flow.
     * @type {boolean}
     * @memberof Oauth2Opts
     */
    explicitWorkspaceRequired: boolean;
    /**
     * A list of URLs that represent the audience for the token, which is needed for some client credential grant flows.
     * @type {Array<string>}
     * @memberof Oauth2Opts
     */
    audience?: Array<string>;
    /**
     * Maps input scopes to their full OAuth scope values with template variable support. Scopes not in this map are passed through unchanged. Needed for some providers.
     * @type {{ [key: string]: string; }}
     * @memberof Oauth2Opts
     */
    scopeMappings?: { [key: string]: string; };
    /**
     * 
     * @type {TokenMetadataFields}
     * @memberof Oauth2Opts
     */
    tokenMetadataFields: TokenMetadataFields;
    /**
     * URL with more information about where to retrieve Client ID and Client Secret, etc.
     * @type {string}
     * @memberof Oauth2Opts
     */
    docsURL?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Oauth2Opts
     */
    authURLParams?: { [key: string]: string; };
    /**
     * 
     * @type {AccessTokenOpts}
     * @memberof Oauth2Opts
     */
    accessTokenOpts?: AccessTokenOpts;
    /**
     * How many hours between proactive token keep-alive refreshes for this provider.
     * Token-manager adds a random stagger offset on top. If absent, defaults to 24.
     * @type {number}
     * @memberof Oauth2Opts
     */
    keepAliveIntervalHours?: number;
    /**
     * The query parameter name used to pass OAuth scopes in the authorization URL.
     * Defaults to "scope" when not specified. Some providers use a different
     * parameter name, such as "user_scope" for Slack user scopes.
     * @type {string}
     * @memberof Oauth2Opts
     */
    scopeQueryParam?: string;
}


/**
 * @export
 */
export const Oauth2OptsGrantTypeEnum = {
    AuthorizationCode: 'authorizationCode',
    AuthorizationCodePkce: 'authorizationCodePKCE',
    ClientCredentials: 'clientCredentials',
    Password: 'password'
} as const;
export type Oauth2OptsGrantTypeEnum = typeof Oauth2OptsGrantTypeEnum[keyof typeof Oauth2OptsGrantTypeEnum];


/**
 * Check if a given object implements the Oauth2Opts interface.
 */
export function instanceOfOauth2Opts(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "grantType" in value;
    isInstance = isInstance && "tokenURL" in value;
    isInstance = isInstance && "explicitScopesRequired" in value;
    isInstance = isInstance && "explicitWorkspaceRequired" in value;
    isInstance = isInstance && "tokenMetadataFields" in value;

    return isInstance;
}

export function Oauth2OptsFromJSON(json: any): Oauth2Opts {
    return Oauth2OptsFromJSONTyped(json, false);
}

export function Oauth2OptsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Oauth2Opts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'grantType': json['grantType'],
        'authURL': !exists(json, 'authURL') ? undefined : json['authURL'],
        'tokenURL': json['tokenURL'],
        'explicitScopesRequired': json['explicitScopesRequired'],
        'explicitWorkspaceRequired': json['explicitWorkspaceRequired'],
        'audience': !exists(json, 'audience') ? undefined : json['audience'],
        'scopeMappings': !exists(json, 'scopeMappings') ? undefined : json['scopeMappings'],
        'tokenMetadataFields': TokenMetadataFieldsFromJSON(json['tokenMetadataFields']),
        'docsURL': !exists(json, 'docsURL') ? undefined : json['docsURL'],
        'authURLParams': !exists(json, 'authURLParams') ? undefined : json['authURLParams'],
        'accessTokenOpts': !exists(json, 'accessTokenOpts') ? undefined : AccessTokenOptsFromJSON(json['accessTokenOpts']),
        'keepAliveIntervalHours': !exists(json, 'keepAliveIntervalHours') ? undefined : json['keepAliveIntervalHours'],
        'scopeQueryParam': !exists(json, 'scopeQueryParam') ? undefined : json['scopeQueryParam'],
    };
}

export function Oauth2OptsToJSON(value?: Oauth2Opts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'grantType': value.grantType,
        'authURL': value.authURL,
        'tokenURL': value.tokenURL,
        'explicitScopesRequired': value.explicitScopesRequired,
        'explicitWorkspaceRequired': value.explicitWorkspaceRequired,
        'audience': value.audience,
        'scopeMappings': value.scopeMappings,
        'tokenMetadataFields': TokenMetadataFieldsToJSON(value.tokenMetadataFields),
        'docsURL': value.docsURL,
        'authURLParams': value.authURLParams,
        'accessTokenOpts': AccessTokenOptsToJSON(value.accessTokenOpts),
        'keepAliveIntervalHours': value.keepAliveIntervalHours,
        'scopeQueryParam': value.scopeQueryParam,
    };
}

